<app-side-top-bar [navigationItems]="navigationItems">
  <main class="documents-page">
    <section class="document-section">
      <header class="header">
        <h2>{{ labelService.getLabel("documents") }}</h2>
        <div class="header-buttons">
          <app-button
            [icon]="'add'"
            (click)="toggleAddDocumentPanel()"
          ></app-button>
        </div>
      </header>

      <div class="chips-container">
        <mat-chip-listbox
          style="width: 100%"
          [(ngModel)]="selectedChips"
          [multiple]="true"
          (change)="onChipSelectionChange($event)"
        >
          @for (category of categories; track category) {
            <mat-chip-option [value]="category">
              {{ category }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>

      @if (modules.length > 0 && !isLoading) {
        <div class="table-container">
          <table
            mat-table
            [dataSource]="selectedModules"
            class="document-table"
          >
            <!-- Category Column -->
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef style="width: 15%">
                Categoria
              </th>
              <td mat-cell *matCellDef="let module">{{ module.category }}</td>
            </ng-container>
            <!-- Title Column -->
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef style="width: 60%">
                Titolo
              </th>
              <td mat-cell *matCellDef="let module">{{ module.title }}</td>
            </ng-container>
            <!-- Formato Column -->
            <ng-container matColumnDef="format">
              <th mat-header-cell *matHeaderCellDef style="width: 15%">
                Formato
              </th>
              <td mat-cell *matCellDef="let module">
                {{ displayFileType(module.file_content_type) }}
              </td>
            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef style="width: 100px"></th>
              <td mat-cell *matCellDef="let module">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  class="action-button"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  @if (module.file_content_type === "application/pdf") {
                    <button
                      mat-menu-item
                      (click)="handleMenuAction('preview', module)"
                    >
                      <mat-icon>visibility</mat-icon>
                      <span>Anteprima</span>
                    </button>
                  }
                  <button
                    mat-menu-item
                    (click)="handleMenuAction('download', module)"
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="handleMenuAction('edit', module)"
                  >
                    <mat-icon>edit</mat-icon>
                    <span>Modifica</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="handleMenuAction('delete', module)"
                  >
                    <mat-icon>delete</mat-icon>
                    <span>Elimina</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      }

      @if (modules.length === 0 && !isLoading) {
        <div class="no-documents">
          <img
            src="assets/imgs/undraw/undraw_empty.svg"
            alt="Nessun Documento"
          />
          <span>Nessun Modulo caricato</span>
        </div>
      }

      @if (isLoading) {
        <div class="loading-container">
          <app-loader [size]="'big'"></app-loader>
        </div>
      }
    </section>

    @if (showAddDocumentPanel) {
      <app-panel-with-document-upload
        [title]="'Nuovo Modulo'"
        [inputBoxes]="inputBoxesForNewModule"
        (cancel)="toggleAddDocumentPanel()"
        (confirm)="confirmNewModule($event)"
      ></app-panel-with-document-upload>
    }

    <!-- modify module panel -->
    @if (showModifyModulePanel) {
      <app-panel-with-document-upload
        [title]="'Modifica Documento'"
        [inputBoxes]="inputBoxesForModifyModule"
        [isEditing]="true"
        (cancel)="toggleModifyPanel()"
        (confirmForEdit)="modifyModule($event)"
      ></app-panel-with-document-upload>
    }
  </main>
</app-side-top-bar>
